import { Link } from "react-router-dom";
import { ago } from "@/lib/format";
import { Activity as ActIcon } from "lucide-react";

const DOT = {
  "transaction.created": "#C8553D", "transaction.accept": "#2E7D32", "transaction.reject": "#DC2626",
  "transaction.request_edit": "#2563EB", "transaction.edited": "#D97706", "settlement.created": "#7C3AED",
  "settlement.accept": "#2E7D32",
};

function target(a) {
  if (a.entity_type === "transaction") return `/txn/${a.entity_id}`;
  if (a.entity_type === "settlement") return `/settlement/${a.entity_id}`;
  if (a.entity_type === "person") return `/person/${a.entity_id}`;
  if (a.holding_id) return `/holding/${a.holding_id}`;
  return null;
}

export default function ActivityList({ items = [], testid = "activity-list" }) {
  if (!items.length)
    return (
      <div className="hd-card text-center py-8 text-sm text-[#718096]" data-testid={`${testid}-empty`}>
        <ActIcon className="mx-auto mb-2 text-[#C8553D]/60" size={24} /> No activity yet
      </div>
    );
  return (
    <div className="hd-card py-1" data-testid={testid}>
      {items.map((a) => {
        const to = target(a);
        const body = (
          <div className="flex gap-3 py-3 border-b border-[#E2D9CF]/50 last:border-0">
            <span className="mt-1.5 w-2 h-2 rounded-full shrink-0" style={{ background: DOT[a.action] || "#A0AEC0" }} />
            <div className="min-w-0">
              <div className="text-sm leading-snug">{a.message}</div>
              <div className="text-xs text-[#718096] mt-0.5">{ago(a.created_at)}</div>
            </div>
          </div>
        );
        return to ? (
          <Link key={a.id} to={to} data-testid={`activity-item-${a.id}`} className="block hover:bg-[#FBF8F4] -mx-4 px-4 transition-colors">{body}</Link>
        ) : (
          <div key={a.id} data-testid={`activity-item-${a.id}`}>{body}</div>
        );
      })}
    </div>
  );
}
